import { Link } from "react-router-dom";
import "./Footer.css";
import GooglePlayIcon from "../../assets/svg/google_play.svg";
import Logo from "../../assets/images/logo (2).png";

const Footer = () => {
  return (
    <footer className="est-footer">
      <div className="est-footer__inner">
        {/* Logo + Brand */}
        <div className="est-footer__brand">
          <Link to="/" className="est-footer__logo">
            <div className="est-footer__logo-icon">
              <img src={Logo} alt="Estetigate Logo" />
            </div>
            <span className="est-footer__logo-text">ESTETIGATE™</span>
          </Link>
        </div>

        {/* Nav Links */}
        <nav className="est-footer__nav">
          <Link to="/" className="est-footer__link">
            Home
          </Link>
          <Link to="/about" className="est-footer__link">
            About
          </Link>
          <Link to="/build-green" className="est-footer__link">
            Build Green
          </Link>
          <Link to="/learn/blogs" className="est-footer__link">
            Learn
          </Link>
          <Link to="/support/faqs" className="est-footer__link">
            Support
          </Link>
        </nav>

        {/* Google Play */}
        <div className="est-footer__store">
          <a
            href="https://play.google.com/store/apps/details?id=com.estetipropertyapp&hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="est-footer__play-btn"
          >
            <div className="est-footer__play-inner">
              <img src={GooglePlayIcon} alt="Google Play" />
            </div>
          </a>
        </div>
      </div>

      {/* Divider + Copyright */}
      <div className="est-footer__bottom">
        <div className="est-footer__divider"></div>
        <p className="est-footer__copyright">
          © 2026 ESTETIGATE™. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
